import { jsx as n } from "react/jsx-runtime";
import { useState as a, useEffect as c } from "react";
import '../../assets/Spinner.css';const l = "_spinner_1e7wd_11", r = {
  "spinner-container": "_spinner-container_1e7wd_11",
  spinner: l
}, p = 250, m = ({ ariaValueText: i, showAfterMs: e = p }) => {
  const [t, s] = a(() => e === 0);
  return c(() => {
    if (e === 0)
      return;
    const o = window.setTimeout(() => {
      s(!0);
    }, e);
    return () => {
      window.clearTimeout(o);
    };
  }), t ? /* @__PURE__ */ n("div", { className: r["spinner-container"], children: /* @__PURE__ */ n("div", { className: r.spinner, role: "progressbar", "aria-label": "Spinner", "aria-valuetext": i }) }) : null;
};
export {
  m as Spinner
};
//# sourceMappingURL=Spinner.js.map
